/**
 * ViewCharacterInfo
 */
import Config from '../Config';
import Template from './Template';
import Util from '../Util';
import GameInfo from '../GameInfo';

class ViewCharacterInfo {

	public onLoaded: any;

	public onFailed: any;

	private $parent: any;

	private gameUser: any;

	private loginUser: any;

	private $signature: any;

	private writerName: any;

	private _id: string;

	private gameCharacterId: string;

	private gameCharacterName: string;

	private communityLevelName: string;

	constructor( $parent: any, gameUser: any, loginUser: any ) {
		this.$parent = $parent;
		this._id = this.$parent.attr( 'id' );
		this.gameUser = gameUser;
		this.loginUser = loginUser;
		this.gameCharacterId = gameUser.gameCharacterId;
		this.gameCharacterName = gameUser.gameCharacterName;

		this.$signature = jQuery( `#${this._id} .view-signature` );
		this.writerName = this.$signature.find( `.writer` ).text() || '';
		this.communityLevelName = this.$signature.find( `.writer .community-level-name`).text() || '';

		this.onLoaded = new Util.Observer();
		this.onFailed = new Util.Observer();

		if ( ( Config.isProfileWithCharName || Config.isHideGameAccountId || this.gameUser.gameUserUid || this.gameCharacterId ) &&
			this.gameUser.gameServerId ) {
			this.get();
		} else {
			this.onFailed.emit();
		}
	}

	public get() {
		const apiUrl = GameInfo.getCharacterInfoAPIUrl( this.gameUser.gameCharacterName,
			this.gameUser.gameServerId, this.gameUser.gameUserUid, this.gameCharacterId );

		const _promise = Util.get( apiUrl, 'GET' );
		_promise.then( ( data: any ) => {
			if ( !data ) {
				return '';
			}

			data.name = ( data.name ) ? data.name : data.characterName;

			if ( !data.name ) {
				return '';
			}

			const tmp = this.template( data );
			this.$signature.replaceWith( tmp );
			this.onLoaded.emit();
		}, ( data: any ) => {
			this.onFailed.emit();
		});
	}

	private template( data: any ) {
		const url = `${ GameInfo.gameUserProfile(data.gameAccountId, '', '', data.name, data.serverId, this.gameCharacterId ) }`;
		const communityLevelName = ( this.communityLevelName ) ?
			Template.communityLevelName( this.communityLevelName ) : '';
		let profileThumb = '';
		let profileWriter = '';

		const profileImage = ( !Util.isUrl( data.profileImageUrl ) ) ?
			`<img data-src="${ data.profileImageUrl }" alt="">` :
			`<img src="${ data.profileImageUrl }" alt="">`;

		if ( Config.isMyProfile ) {
			profileThumb = `<a href="${ url }">${ profileImage }</a>`;
			profileWriter = `<a href="${ url }">${ data.name }</a>`;
		} else {
			profileThumb = profileImage;
			profileWriter = `${ data.name }`;
		}

		// ${ ( data.guildName ) ? `<span class="clan">${ data.guildName }</span>` : ``}
		return `<div class="view-signature">
			<div class="thumb">${profileThumb}</div>
			<div class="writer">${communityLevelName}${profileWriter}</div>
			<div class="info">
			${ ( data.serverName ) ? `<span class="servername">${ data.serverName }</span>` : ``}
			${ ( data.guild && data.guild.guildName ) ? `<span class="clan">${ data.guild.guildName }</span>` : ``}
			${ ( data.raceName ) ? `<span class="race">${ data.raceName }</span>` : ``}
			</div>
		</div>`;
	}
}

export default ViewCharacterInfo;
